import axios from '@service'
import { GET_MEMBERT_ROSTER_BY_TEAM_ID } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

export default async function getMemberService(payload = {}, config = {}) {
    const param = {
        ...GET_MEMBERT_ROSTER_BY_TEAM_ID,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
